import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';

import Modal from 'components/Modals/presets/BasicModal';
import type { BillingCadence } from '../PlanSummary';

type DowngradeCancellationDialogProps = {
  currentCadence: BillingCadence;
} & Record<string, any>;

export const DowngradeCancellationDialog = (
  props: DowngradeCancellationDialogProps
) => {
  const { t } = useTranslation();
  const { currentCadence, ...rest } = props;
  const modalProps = rest as any;

  const cadenceLabel = currentCadence === 'year' ? t('annual') : t('monthly');

  return (
    <Modal
      {...modalProps}
      heading={t('Confirm Plan Change Cancellation')}
      buttonText={t('Cancel Pending Plan')}
      actionBtnColor="red"
      defaultLeftBtnText={t('Keep Pending Plan')}
    >
      <div className="pb-2">
        <Typography>
          {t(
            'Please confirm the cancellation of the pending plan change. The business will remain on the current {{cadence}} plan.',
            { cadence: cadenceLabel }
          )}
        </Typography>
      </div>
    </Modal>
  );
};
